import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

export const onRouteUpdate = () => {
    if (typeof document === "undefined") return

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {

                /* fadeInUp（1回だけでOKなやつ） */
                if (entry.target.classList.contains("fadeInUp")) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("on")
                    }
                }

                /* 線アニメ・囲み系（何度も再生したいやつ） */
                if (entry.target.classList.contains("js-toggle-active")) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("is-active")
                    } else {
                        entry.target.classList.remove("is-active")
                    }
                }

            })
        },
        { threshold: 0.2 }
    )

    /* 1回だけ系 */
    document
        .querySelectorAll(".fadeInUp")
        .forEach(el => observer.observe(el))

    /* トグル系（円・囲み線） */
    document
        .querySelectorAll(".js-toggle-active")
        .forEach(el => observer.observe(el))
}

export const onClientEntry = () => {
    if (typeof document !== "undefined") {
        document.documentElement.classList.add("js")
    }
}
